import { yupResolver } from "@hookform/resolvers/yup";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { contentPrivacyAndTermsSchema } from "../../../helpers";
import { DescriptionField } from "./atoms";
import { PrivacyFormProps, PrivacyFormValues } from "./PrivacyForm.types";

import styles from "./PrivacyForm.module.scss";

const PrivacyForm = ({
  formId,
  defaultValues,
  onSubmit,
  isLoadingUpdate
}: PrivacyFormProps) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty }
  } = useForm<PrivacyFormValues>({
    defaultValues,
    resolver: yupResolver(contentPrivacyAndTermsSchema)
  });

  const onCancel = () => {
    reset();
  };

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.form_inputs}>
        <DescriptionField
          control={control}
          name="privacy"
          label={t("Privacy Policy")}
          placeholder={t("Enter Privacy Policy")}
        />
        <DescriptionField
          control={control}
          name="terms"
          label={t("Terms of Service")}
          placeholder={t("Enter Terms of Service")}
        />
      </div>

      <div className={styles.form_divider} />
      <div className={styles.form_buttons}>
        <Button type="button" variant="default" block onClick={onCancel}>
          {t("Cancel")}
        </Button>
        <Button
          type="submit"
          form={formId}
          variant={"primary"}
          loading={isLoadingUpdate}
          block
          onClick={undefined}
          disabled={!isDirty}
        >
          {t("Save")}
        </Button>
      </div>
    </form>
  );
};

export default PrivacyForm;
